module.exports = __webpack_public_path__ + "static/media/solution-1-sec2.73f62949.png";